import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Wellmark Blue Cross and Blue Shield",
  shortName: "Wellmark",
  slug: "wellmark-insurance",
  seoTitle:
    "Wellmark Blue Cross and Blue Shield TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Wellmark Blue Cross and Blue Shield policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Wellmark TMS coverage, Wellmark Blue Cross SPRAVATO authorization, Wellmark mental health benefits Coral Springs FL, Wellmark depression treatment Florida",
};

export const WellmarkInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default WellmarkInsurance;
